import * as React from 'react';
import classnames from 'classnames';

const ProductBlockGridContainer = ({ 'data-t': dataT , hasDivider , children ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        "data-t": dataT,
        className: classnames('product-block-grid-container', {
            'product-block-grid-container--with-divider': hasDivider
        })
    }, children);
};

export { ProductBlockGridContainer };
//# sourceMappingURL=ProductBlockGridContainer.js.map
